import { render, staticRenderFns } from "./StudentView.vue?vue&type=template&id=3c8844ed&"
import script from "./StudentView.vue?vue&type=script&lang=js&"
export * from "./StudentView.vue?vue&type=script&lang=js&"
import style0 from "./StudentView.vue?vue&type=style&index=0&id=3c8844ed&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports